import React from 'react';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  city: string;
  text: string;
  gender: 'male' | 'female';
}
const testimonials: Testimonial[] = [{
  name: 'María Fernanda López',
  age: 42,
  city: 'Córdoba',
  gender: 'female',
  text: 'Llevo 15 años dando clases de Seguridad e Higiene y cada año era lo mismo: semanas armando programas, buscando casos nuevos, preparando evaluaciones. Este manual me cambió todo. Ahora tengo todo organizado y puedo dedicar mi tiempo a lo que realmente importa: enseñar.'
}, {
  name: 'Carlos Alberto Ruiz',
  age: 38,
  city: 'Rosario',
  gender: 'male',
  text: 'Empecé a dar clases hace 3 años y me sentía perdido con la planificación. No sabía por dónde empezar. El manual me dio una estructura clara y profesional. Mis alumnos notan la diferencia y yo ya no paso noches armando material.'
}, {
  name: 'Luciana Martínez',
  age: 35,
  city: 'Buenos Aires',
  gender: 'female',
  text: 'Entre el trabajo, la familia y las clases, no me daba el tiempo para preparar todo como quería. Los casos profesionales del manual son exactamente lo que necesitaba. Reales, aplicables y listos para usar. Una inversión que se paga sola.'
}, {
  name: 'Jorge Raúl Pereyra',
  age: 50,
  city: 'Mendoza',
  gender: 'male',
  text: 'Con 25 años de experiencia en el rubro, pensé que no necesitaba ayuda. Pero este manual me sorprendió. La organización progresiva por año y las rúbricas técnicas son de un nivel profesional que no había visto. Lo recomiendo a todos mis colegas.'
}, {
  name: 'Valentina Sosa',
  age: 29,
  city: 'Tucumán',
  gender: 'female',
  text: 'Recién egresada y con mi primer cargo docente, estaba aterrada de no estar a la altura. El manual me dio la confianza que necesitaba. Tengo todo el año planificado, evaluaciones profesionales y casos que impresionan a mis alumnos. ¡Gracias!'
}];
function StarRating() {
  return <div className="flex gap-1 mb-3" data-id="element-232">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-233" />)}
    </div>;
}
export function TestimonialSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-234">
      <div className="max-w-4xl mx-auto" data-id="element-235">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-236">
          Lo que dicen otros docentes que probaron el material
        </h2>
        <div className="space-y-5" data-id="element-237">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-5 shadow-md border border-gray-100" data-id="element-238">
              <StarRating data-id="element-239" />
              <p className="text-gray-700 text-lg italic mb-4" data-id="element-240">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-241">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center text-white font-bold text-lg" data-id="element-242">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-243">
                  <p className="font-semibold text-gray-900" data-id="element-244">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-245">
                    {testimonial.age} años, {testimonial.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}